import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Card, CardContent, Divider, List, ListItem, ListItemIcon, ListItemText, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import DescriptionIcon from "@material-ui/icons/Description";
import YouTubeIcon from "@material-ui/icons/YouTube";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import * as Admin from "../../../store/ducks/admin.duck";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },

  panel: {
    borderRadius: 12,
    height: "100%",
  },

  panelContent: {
    padding: theme.spacing(2),
  },
}));

export default function Resources() {
  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Admin.actions.fetchResourceItems());
  }, [dispatch]);
  const resourceItems = useSelector((state) => state.admin.ResourceItems);
  const centralisedResources = resourceItems.filter((x) => x.type === "CentralisedService");
  const providerCentralisedResources = resourceItems.filter((x) => x.type === "ProviderCentralisedService");
  const generalResources = resourceItems.filter((x) => x.type === "General");
  const role = useSelector((state) => state.auth.roleDesc);

  const visiblePanels = [centralisedResources.length > 0, providerCentralisedResources.length > 0, generalResources.length > 0].filter(Boolean).length;
  const mdSize = visiblePanels <= 2 ? 6 : 4;

  const renderResourcePanel = (title, items) => (
    <Card className={classes.panel}>
      <CardContent className={classes.panelContent}>
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>

        <Divider />

        <List dense>
          {items.map((item) => {
            const isPdf = item.pdf_url !== "";

            const url = isPdf ? `https://files.ruralhealthconnect.com.au/fileStoreRHC/${item.pdf_url}` : item.youtube_url;

            return (
              <React.Fragment key={item.title}>
                <ListItem button component="a" href={url} target="_blank" rel="noopener noreferrer">
                  <ListItemIcon>{isPdf ? <DescriptionIcon color="primary" /> : <YouTubeIcon color="secondary" />}</ListItemIcon>

                  <ListItemText primary={item.title} />

                  <Chip size="small" label={isPdf ? "PDF" : "Video"} />

                  <OpenInNewIcon color="action" style={{ marginLeft: 12 }} />
                </ListItem>

                <Divider />
              </React.Fragment>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );

  return (
    <div className={classes.root}>
      <Typography variant="h4" gutterBottom>
        Resources
      </Typography>

      <Typography color="textSecondary" paragraph>
        Browse our collection of resources.
      </Typography>

      <Grid container spacing={3}>
        {centralisedResources.length > 0 && (
          <Grid item xs={12} md={mdSize}>
            {renderResourcePanel(role === "Admin" ? "Centralised Service - Staff" : "Centralised Service", centralisedResources)}
          </Grid>
        )}

        {providerCentralisedResources.length > 0 && (
          <Grid item xs={12} md={mdSize}>
            {renderResourcePanel(role === "Admin" ? "Centralised Service - Provider" : "Centralised Service", providerCentralisedResources)}
          </Grid>
        )}

        {generalResources.length > 0 && (
          <Grid item xs={12} md={mdSize}>
            {renderResourcePanel("General", generalResources)}
          </Grid>
        )}
      </Grid>
    </div>
  );
}
